import type { KitItem } from "@/types";

// Contenido inicial del Kit de Ventas & Marketing. El administrador puede
// editarlo por completo desde su panel; estos son los elementos por defecto que
// se muestran cuando todavía no se ha personalizado nada.
export const DEFAULT_KIT_ITEMS: KitItem[] = [
  {
    id: "kit-default-1",
    title: "Nutrición que transforma",
    text: "Con los suplementos Amway cuidas tu energía y tu bienestar todos los días. Escríbeme y te asesoro con el producto ideal para ti. 🍃",
    imageUrl:
      "https://readdy.ai/api/search-image?query=Clean%20studio%20product%20photography%20of%20a%20nutrition%20supplement%20bottle%20on%20a%20soft%20neutral%20beige%20background%20with%20warm%20natural%20light%2C%20minimal%20elegant%20aesthetic%2C%20soft%20shadows%2C%20high%20detail&width=800&height=800&seq=attd-kit-nutrition-01&orientation=squarish",
    createdAt: "2026-01-01T00:00:00.000Z",
  },
  {
    id: "kit-default-2",
    title: "Belleza radiante",
    text: "Tu rutina de belleza merece lo mejor. Productos Amway con calidad garantizada para verte y sentirte increíble. Pregúntame por tu combo. ✨",
    imageUrl:
      "https://readdy.ai/api/search-image?query=Elegant%20studio%20photography%20of%20a%20skincare%20cosmetic%20bottle%20on%20a%20soft%20blush%20pink%20neutral%20background%20with%20gentle%20light%2C%20luxurious%20minimal%20beauty%20aesthetic%2C%20soft%20shadows%2C%20high%20detail&width=800&height=800&seq=attd-kit-beauty-01&orientation=squarish",
    createdAt: "2026-01-01T00:00:00.000Z",
  },
  {
    id: "kit-default-3",
    title: "Hogar impecable",
    text: "Mantén tu hogar limpio, seguro y con aroma fresco. Los productos de limpieza Amway rinden más y cuidan a tu familia. Escríbeme. 🏠",
    imageUrl:
      "https://readdy.ai/api/search-image?query=Clean%20studio%20photography%20of%20a%20home%20cleaning%20product%20bottle%20on%20a%20soft%20mint%20neutral%20background%20with%20fresh%20natural%20light%2C%20minimal%20modern%20aesthetic%2C%20soft%20shadows&width=800&height=800&seq=attd-kit-home-01&orientation=squarish",
    createdAt: "2026-01-01T00:00:00.000Z",
  },
  {
    id: "kit-default-4",
    title: "Cuidado personal premium",
    text: "Aseo personal de calidad que cuida tu piel y tu cabello. Descubre la línea Amway y consiente a tu cuerpo. Te cuento precios. 💧",
    imageUrl:
      "https://readdy.ai/api/search-image?query=Premium%20studio%20photography%20of%20a%20personal%20care%20product%20bottle%20on%20a%20soft%20lavender%20neutral%20background%20with%20gentle%20diffused%20light%2C%20minimal%20luxury%20aesthetic%2C%20soft%20shadows&width=800&height=800&seq=attd-kit-care-01&orientation=squarish",
    createdAt: "2026-01-01T00:00:00.000Z",
  },
  {
    id: "kit-default-5",
    title: "Promoción del mes",
    text: "¡Aprovecha las promociones del mes! Combos con precio especial y entregas a domicilio. Cupos limitados, escríbeme ya. 🔥",
    imageUrl:
      "https://readdy.ai/api/search-image?query=Modern%20promotional%20still%20life%20with%20gift%20boxes%20and%20product%20bottles%20on%20a%20clean%20coral%20neutral%20background%2C%20festive%20elegant%20minimal%20aesthetic%2C%20soft%20warm%20light&width=800&height=800&seq=attd-kit-promo-01&orientation=squarish",
    createdAt: "2026-01-01T00:00:00.000Z",
  },
  {
    id: "kit-default-6",
    title: "Emprende conmigo",
    text: "¿Quieres un ingreso extra desde casa? Únete a mi red Amway y empieza a vender con acompañamiento. Te explico cómo. 🚀",
    imageUrl:
      "https://readdy.ai/api/search-image?query=Bright%20aspirational%20still%20life%20of%20a%20laptop%20and%20notebook%20on%20a%20clean%20soft%20yellow%20neutral%20background%2C%20modern%20minimal%20business%20aesthetic%2C%20soft%20natural%20light&width=800&height=800&seq=attd-kit-team-01&orientation=squarish",
    createdAt: "2026-01-01T00:00:00.000Z",
  },
];